/**
 * afBuffer
 *
 * most functionalities are disabled due to uncompatibility
 * basically only adds current main form data to each request
 *
 * @category    af
 * @package     Buffer
 * @version     $Id: buffer.js 132841 2018-05-25 12:25:32Z ahe $
 * @copyright   Copyright (c) Alcedis GmbH
 * @author      Markus Michalsky
 * @author      Alexander Waclawczyk
 */
var afBuffer = (function () {
    /**
     * internal pointer
     *
     * @access  private
     * @var     afBuffer
     */
    var self = {};


    /**
     * debug mode, spams console with warn-logs of every action
     *
     * @access  private
     * @var     boolean
     */
    var _debug = false;


    /**
     * data object
     *
     * @access  private
     * @var     object
     */
    var _data = null;


    /**
     * mainform model (never changes)
     *
     * @access  private
     * @var     string
     */
    var _model = af.camelcase(pool.controller, '-');


    /**
     * fieldlist
     * only post vars in this list will be synched
     * loaded once on non-ajax rec action
     * contains all relevant relation fields
     *
     * @access  private
     * @var     array
     */
    var _fields = null;


    /**
     * id of current posform (if we are actually in one)
     *
     * @access  private
     * @var     string
     */
    var _posformId = null;


    /**
     * backup of data before entering posform
     * is written when entering posform
     * is restored if posform was not saved and closed
     *
     * @access  private
     * @var     object
     */
    var _dataBackup = null;


    /**
     * last sent posdata post var
     *
     * @access  private
     * @var     string
     */
    var _posData = null;


    /**
     * sync _data object with post-data
     *
     * @access  private
     * @param   string  model
     * @param   object  record
     * @param   object  data
     * @return  object
     */
    var _iterateData = function (model, record, data) {
        for (i in data) {
            var name = data[i].name;
            var value = data[i].value;

            if (_fields !== null && _fields[model] !== undefined
                && (af.inArray(name, _fields[model]) === true || name === '__uniqRefId__')) {
                record[name] = value;
//            } else if (af.string.contains(name, '--') === true) {
//                var relationParts = name.split('--');
//                var relation = af.camelcase(relationParts[0], '-');
//                var field = relationParts[1];
//
//                if (record[relation] === undefined) {
//                    record[relation] = {};
//                }
//
//                if (af.inArray(field, _fields[relation]) === true) {
//                    record[relation][field] = value;
//                }
//            } else if (name === 'posdata') {
//                _posData = value;
            } else if (af.string.endsWith(name, '_i18n') === false && af.string.startsWith(name, '__') === false) {
                _debug && console.warn('afBuffer: sync failed for "' + name + '" on "' + model + '"');
            }
        }

        return record;
    };


    /**
     * sync data from posform models
     *
     * @access  private
     * @param   string  model
     * @param   object  data
     * @return  void
     */
    var _syncPos = function (model, data) {
        // if no pos records exists yet
        if (_data[model] === undefined) {
            _data[model] = [];
        }

        // search for record in _data object
        var key = undefined;
        for (i in _data[model]) {
            var record = _data[model][i];
            if (_posformId == record.__uniqRefId__ || (record.__uniqRefId__ === undefined && _posformId == record.id)) {
                key = i;
                break;
            }
        }

        // if no record was found, create a new one
        if (key === undefined) {
            _data[model].push(_iterateData(model, {}, data));
        } else {
            _iterateData(model, _data[model][key], data);
        }
    };


    /**
     * clones an object using json parse/strinfigy
     *
     * @access  private
     * @param   object
     * @return  object
     */
    var _clone = function (obj) {
        return JSON.parse(JSON.stringify(obj));
    };


    /**
     * removes empty id fields from data object to let doctrine handle the rest on the server side
     * only use on copy of _data object, not the original!
     *
     * @access  private
     * @param   object  data
     * @return  void
     */
    var _clean = function (data) {
        for (i in data) {
            if (typeof data[i] === 'object' && data[i] !== null) {
                _clean(data[i]);
            } else if (i === '__uniqRefId__' || ((af.string.endsWith(i,  '_id') || i === 'id') === true
                && af.isEmpty(data[i]) === true)
            ) {
                delete(data[i]);
            }
        }
    };


    /**
     * add something to something
     *
     * data is only added if check key does not exist in data
     *
     * @access  private
     * @param   array|object    data
     * @param   string          key
     * @param   mixed           key
     */
    var _add = function (data, key, value, ignore) {
        if (af.isEmpty(value) === true) {
            return;
        }

        if ($.isArray(data) === true && _notIn(key, data) === true) {
            if (ignore === undefined || _notIn(ignore, data) === true) {
                data.push({name: key, value: value});
            }
        } else if (data[key] === undefined) {
            if (ignore === undefined || data[ignore] === undefined) {
                data[key] = value;
            }
        }
    };


    /**
     * check if no object with attribute 'name' === name exists in data array
     *
     * @access  private
     * @pararm  string  name
     * @param   array   data
     * @return  boolean
     */
    var _notIn = function (name, data) {
        for (i in data) {
            if (data[i] !== undefined && data[i] !== null && data[i]['name'] === name) {
                return false;
            }
        }

        return true;
    }


    /**
     * getter / setter for posformId
     *
     * @access  public
     * @pararm  mixed   id
     * @return  mixed
     */
    self.setPosformId = function (id) {
        _debug && console.warn('afBuffer: setting posform id "' + id + '"');

        if (_posformId === null) {
            _posformId = id;
        } else {
            console.error('afBuffer: trying to overwrite _posformId "' + _posformId + '" with "' + id + '"');
        }

        return self;
    };


    /**
     * get posformId
     *
     * @access  public
     * @return  string
     */
    self.getPosformId = function() {
        return _posformId;
    };


    /**
     * sync post data with _data object
     *
     * @access  public
     * @param   string  model
     * @param   object  data
     * @return  void
     */
    self.sync = function (model, data) {
        _debug && console.warn('afBuffer: sync buffer data');

        if (_posformId !== null) {
            data.push({name: '__uniqRefId__', value: _posformId});
        }

        model = af.camelcase(model, '-');
        if (model !== _model) {
//            _syncPos(model, data); // no pos at the moment
        } else {
            _posformId = null;
            _iterateData(model, _data, data);
        }
    };

    /**
     * remove posform record from _data object
     *
     * @access  public
     * @param   string  model
     * @param   string  id
     * @return  void
     */
    self.remove = function (model, id) {
        model = af.camelcase(model, '-');
        _debug && console.warn('afBuffer: remove entry "' + id + '" from "' + model + '"');
        var isRefId = af.string.startsWith(id, '__') && af.string.endsWith(id, '__');

        if (_data[model] !== undefined) {
            for (i in _data[model]) {
                var record = _data[model][i];
                if (record[isRefId ? '__uniqRefId__' : 'id'] == id) {
                    delete(_data[model][i]);
                    _data[model] = af.cleanArray(_data[model]);
                    break;
                }
            }
        }
    };


    /**
     * set model (only done once in non-ajax rec action)
     *
     * @access  public
     * @param   string  model
     * @return  void
     */
    self.setModel = function (model) {
        _debug && console.warn('afBuffer: set base model "' + model + '"');

        if (_model === null) {
            _model = model;
        } else {
            console.error('afBuffer: model is already set');
        }
    };


    /**
     * initial data setter (only done once in non-ajax rec action)
     *
     * @access  public
     * @param   object  data
     * @return  void
     */
    self.setData = function (data) {
        _debug && console.warn('afBuffer: init data');

        if (_data === null) {
            if (Object.keys(data).length === 0) {
                _data = self.getEmptyRecord();
            } else {
                _data = data;
            }
        } else {
            console.error('afBuffer: data is already set');
        }
    };


    /**
     * creates record object with fieldnames and empty values
     *
     * @access public
     * @returns {{}}
     */
    self.getEmptyRecord = function () {
        var record = {};
        var fields = _fields[_model];

        for (var i = 0; i < fields.length; i++) {
            record[fields[i]] = "";
        }

        return record;
    }


    /**
     * initial field setter (only once in non-ajax rec action)
     * if a model or a field is not in this array it will not be synched
     *
     * @access  public
     * @param   array   fields
     * @return  void
     */
    self.setFields = function (fields) {
        _debug && console.warn('afBuffer: set fields');

        if (_fields === null) {
            _fields = fields;
        } else {
            console.error('afBuffer: fields are already set');
        }
    };


    /**
     * posform close action
     * resets _data with _dataBackup
     *
     * @access  public
     * @return  void
     */
    self.revert = function () {
        if (_dataBackup !== null) {
            _debug && console.warn('afBuffer: revert posform changes');
            _data = _clone(_dataBackup);
            _dataBackup = null;
            _posformId = null;
        }
    };


    /**
     * posform save action
     * empties _dataBackup object
     *
     * @access  public
     * @return  void
     */
    self.confirm = function () {
        if (_dataBackup !== null) {
            // gets called multiple times due to minor bug in jquery.polist.js
            _debug && console.warn('afBuffer: confirm posform changes');
            _dataBackup = null;
        }
    };


    /**
     * clones _data object to _dataBackup
     *
     * @access  public
     * @return  void
     */
    self.backup = function () {
        _debug && console.warn('afBuffer: create backup');

        if (_dataBackup === null) {
            _dataBackup = _clone(_data);
        } else {
            console.error('afBuffer: dataBackup is already set');
        }

    };


    /**
     * adds __formData__ entry to post data
     *
     * @access  public
     * @param   string          model
     * @param   array|object    data
     * @return  void
     */
    self.include = function (model, data) {
        _debug && console.warn('afBuffer: add post data');
//        model = af.camelcase(model, '-');
//        var dataCopy = {};

        // posform action
//        if (&& model !== _model) {
//            var key = null;
//            for (i in _data[model]) {
//                if (_posformId == _data[model][i].__uniqRefId__ ||
//                        (_data[model][i].__uniqRefId__ === undefined && _posformId == _data[model][i].id)
//                ) {
//                    key = i;
//                    break;
//                }
//            }
//
//            if (key === null) {
//                dataCopy[_model] = _clone(_data);
//            } else {
//                dataCopy = _clone(_data[model][key]);
//                dataCopy[_model] = _clone(_data);
//            }
//        } else {
        var dataCopy = {};
        dataCopy[_model] = _clone(_data);
//        }

        _clean(dataCopy);

        _add(data, '__formData__', JSON.stringify(dataCopy));
//        _add(data, '__uniqRefId__', _posformId);
       _add(data, '__parentRecord__', _model);
//        _add(data, '__posData__', _posData, 'posdata');
    };

    return self;
})();
